/**
 * @desc 修改调拨单渠道/平台
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.AllocationMasterParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/changeChannel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
